import { render, staticRenderFns } from "./erroralert.vue?vue&type=template&id=037ef466"
import script from "./erroralert.vue?vue&type=script&lang=js"
export * from "./erroralert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports